import { TypedTranslation } from '../../translation/types';

/**
 * Important information about these textkeys:
 * These textkeys are used in the root container of the Sportsbook application and thus it is important that all textkeys in this enum are preloaded in
 * the `preloaded-text-keys.txt` file to ensure that we can start rendering of the Sportsbook application as soon as possible.
 *
 ** If you are adding new textkeys here please make sure to add them to the `preloaded-text-keys.txt` file as well.
 */
enum SportsbookTextKeys {
	EXPLORE_NAV_LABEL = 'SPORTSBOOK_EXPLORE_NAV_LABEL',
	BROWSE_NAV_LABEL = 'SPORTSBOOK_BROWSE_NAV_LABEL',
	MY_BETS_NAV_LABEL = 'SPORTSBOOK_MY_BETS_NAV_LABEL',
	LIVE_GAMES_PAGE_NAV_LABEL = 'SPORTSBOOK_LIVE_GAMES_PAGE_NAV_LABEL',
	SEARCH_NAV_LABEL = 'SPORTSBOOK_SEARCH_NAV_LABEL',
	SEARCH_NAV_LABEL_SECONDARY = 'SPORTSBOOK_SEARCH_NAV_LABEL_SECONDARY',
	LIVE_TAB_LABEL = 'SPORTSBOOK_LIVE_TAB_LABEL',
	UPCOMING_TAB_LABEL = 'SPORTSBOOK_UPCOMING_TAB_LABEL',
	ODDS_UPDATING_LABEL = 'SPORTSBOOK_ODDS_UPDATING_LABEL',
	NO_ODDS_AVAILABLE_TITLE = 'SPORTSBOOK_NO_ODDS_AVAILABLE_TITLE',
	LIVE = 'SPORTSBOOK_LIVE',
	STREAM = 'SPORTSBOOK_STREAM',
	LIVE_STREAM = 'SPORTSBOOK_LIVE_STREAM',
	MORE_ODDS = 'SPORTSBOOK_MORE_ODDS',
	SEE_ALL_LABEL = 'SPORTSBOOK_SEE_ALL_LABEL',
	TOTAL_TAX_LABEL = 'SPORTSBOOK_TOTAL_TAX_LABEL',
	TOTAL_STAKE_TAX_LABEL = 'SPORTSBOOK_TOTAL_STAKE_TAX_LABEL',
	TOTAL_STAKE_AFTER_TAX_LABEL = 'SPORTSBOOK_TOTAL_STAKE_AFTER_TAX_LABEL',
	TOTAL_POTENTIAL_RETURNS_TAX_LABEL = 'SPORTSBOOK_TOTAL_POTENTIAL_RETURNS_TAX_LABEL',
	BET_BUILDER_BET_TITLE = 'SPORTSBOOK_BET_BUILDER_BET_TITLE',
	SELECT_PREFERRED_MARKET_TYPE_TITLE = 'SPORTSBOOK_SELECT_PREFERRED_MARKET_TYPE_TITLE',
	BET_BUILDER_TOOLTIP_LABEL = 'SPORTSBOOK_BET_BUILDER_TOOLTIP_LABEL',
	SUPER_SUB_TOOLTIP_LABEL = 'SPORTSBOOK_SUPER_SUB_TOOLTIP_LABEL',
	TODAY_LABEL = 'SPORTSBOOK_EVENT_DAY_FILTER_BAR_TODAY_LABEL',
	CONNECTION_LOST_INFORM = 'SPORTSBOOK_NOTIFICATION_CONNECTION_LOST_INFORM',
	CONNECTION_LOST_INFORM_AND_RELOAD = 'SPORTSBOOK_NOTIFICATIONS_CONNECTION_LOST_INFORM_AND_RELOAD',
	CONNECTION_LOST_INFORM_AND_RELOAD_BUTTON_LABEL = 'SPORTSBOOK_NOTIFICATION_CONNECTION_LOST_INFORM_AND_RELOAD_BUTTON_LABEL',
	WIDGET_TAB_TITLE_MATCH_TRACKER = 'SPORTSBOOK_WIDGET_TAB_TITLE_MATCH_TRACKER',
	WIDGET_ERROR_MESSAGE_TITLE = 'SPORTSBOOK_WIDGET_ERROR_MESSAGE_TITLE',
	WIDGET_ERROR_MESSAGE_DESCRIPTION = 'SPORTSBOOK_WIDGET_ERROR_MESSAGE_DESCRIPTION',
	SELECTION_BUTTON_ARIA_LABEL = 'SPORTSBOOK_SELECTION_BUTTON_ARIA_LABEL',
	TOGGLE_SHOW_MORE = 'SPORTSBOOK_TOGGLE_SHOW_MORE',
	TOGGLE_SHOW_LESS = 'SPORTSBOOK_TOGGLE_SHOW_LESS'
}

export const SPORTSBOOK_TEXT_KEYS = Object.values(SportsbookTextKeys);

export type SportsbookTranslations = Readonly<TypedTranslation<typeof SportsbookTextKeys>>;

export default SportsbookTextKeys;
